import { MemoryTable } from './MemoryTable'
export default MemoryTable
